import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { ProgressSpinner } from 'primereact/progressspinner';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { PendenciasWizard, setPendencia } from './ValidacaoWizard';

import { dominioDemandaCirurgica, dominioOperaAspNet } from '../../config/database';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '200px !important',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 2,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function SelecaoInternacao(props) {
  const classes = useStyles();
  const { internacao, closeModal } = props;
  const [loading, setLoading] = React.useState(false);

  const handleClick = async (event, row) => {
    const atendimento = {
      SEQ_ATENDIMENTO: row.SEQ_ATENDIMENTO,
      DAT_HORA_ATENDIMENTO: row.DAT_HORA_ATENDIMENTO,
      NRO_FAA: row.NRO_FAA,
      NOM_CARATER_ATENDIMENTO: row.NOM_CARATER_ATENDIMENTO,
    };
    setPendencia(0, PendenciasWizard.atendimentoInternacao, 'pendenciasPaciente');
    const paciente = JSON.parse(localStorage.getItem('paciente'));
    paciente.COD_LEITO = row.COD_LEITO;
    localStorage.removeItem('paciente');
    localStorage.setItem('paciente', JSON.stringify(paciente));

    localStorage.setItem('atendimento', JSON.stringify(atendimento));
    localStorage.setItem('internacao', JSON.stringify(row));
    localStorage.setItem('dataInternacao', format(parseISO(row.DAT_HORA_INTERNACAO), 'yyyy-MM-dd'));
    setLoading(true);
    dominioOperaAspNet.get(`/api/listaexamesselecaointernacaoopera/${row.SEQ_INTERNACAO}`).then(
      async response => {
        let exames = [];
        await dominioDemandaCirurgica.get('/api/itemExame').then(resExames => {
          exames = resExames.data
            .filter(exame =>
              response.data.some(examesSihosp => exame.idLegado === examesSihosp.SEQ_EXAME)
            )
            .sort((exameA, exameB) => {
              if (exameA.descricao < exameB.descricao) {
                return -1;
              }
              if (exameA.descricao > exameB.descricao) {
                return 1;
              }
              return 0;
            });
        });
        localStorage.setItem('examesAtendimento', JSON.stringify(exames));
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );

    closeModal();
  };

  if (loading) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <div className={classes.root}>
      <Toolbar>
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          Selecione a internação
        </Typography>
      </Toolbar>
      <TableContainer>
        <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
          <TableBody>
            <TableRow
              hover
              onClick={event => handleClick(event, internacao)}
              tabIndex={-1}
              key={internacao.name}
              style={{ cursor: 'pointer' }}
            >
              <TableCell align="left">
                <div>
                  <span className="titulo-card-modal">
                    <strong>Data internação:</strong>
                  </span>
                  {new Date(internacao.DAT_HORA_INTERNACAO).toLocaleString()}
                </div>
                <div>
                  <span className="titulo-card-modal">
                    <strong>Nº Internação:</strong>
                  </span>
                  {internacao.NRO_INTERNACAO}
                </div>
                <div>
                  <span className="titulo-card-modal">
                    <strong>Caráter:</strong>
                  </span>
                  {internacao.NOM_CARATER_ATENDIMENTO}
                </div>
                <div>
                  <span className="titulo-card-modal">
                    <strong>Especialidade:</strong>
                  </span>
                  {internacao.NOM_CENTRO_CUSTO}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
